import { Text } from '@dhl-official/react-ui-library';
import React from 'react';
import { TEXT_SIZES, TEXT_WEIGHTS } from '../../../types';

const InfoModal = ({
    size = TEXT_SIZES['MD'],
    weight = TEXT_WEIGHTS[400],
    className = '',
    children,
    ...restProps
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) => {
    return (
        <Text isParagraph size={size} weight={weight} className={`mb-0 ${className}`} {...restProps}>
            {children}
        </Text>
    );
};

export default InfoModal;
